// removed by extract-text-webpack-plugin
module.exports = {"pic":"_17AVKYqw4kiuZIVuFX7c0q","selected":"iwADfd5U8mQsBglg8sUFP"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/InstagramPicker/InstagramPic.scss
 ** module id = 732
 ** module chunks = 0
 **/